import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link, useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {bindActionCreators} from 'redux'
import {actionsGUEditarUsuario} from '../../../actions/action-creators'
import {
  gu_eu_Clear,
  gu_eu_OpenModalEliminarUsuario,
} from '../../../actions/gestion-usuario/editar-usuario/editarUsuario.actions'
import WhiteCheck from '../../../media/felsv/white_check_icon.svg'
import ModalDelete from '../../../components/Modals/Generales/ModalDelete'
import InputPhone from '../../../components/Inputs/InputPhone'
import { getTiposDocumento } from '../../../actions/catalogos.actions'
import { generalOpenConfirmEdit } from '../../../actions/general.actions'
import Autorizado from '../../../components/Autorizado/Autorizado'
import {CATALOGO_ROLES, ROLES_GESTION_DE_ROLES, ROL_POR_OMISION} from '../../../constants/roles'

const EditarUsuario = () => {
  const {formUser, formError, usuarioSeleccionado, modales} = useSelector(
    (state: State) => state.gestionUsuario.editarUsuario
  )
  const {tipoDocumento} = useSelector((state: State) => state.catalogos)
  const history = useHistory()
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUEditarUsuario, dispatch)

  useEffect(() => {
    if (usuarioSeleccionado === null) return cancelar()
    dispatch(getTiposDocumento())
    window.scroll(0, 0)
    return () => {
      dispatch(gu_eu_Clear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const cancelar = () => history.push('/gestion-usuarios/listar-usuarios')

  const submit = (e: any) => {
    e.preventDefault()
    dispatch(generalOpenConfirmEdit(() => action_submit(e)))
  }
  const action_submit = (e: any) => {
    const hasErrors = Object.values(formError).some((value) => !!value);
    if (!hasErrors) {
      actions.gu_eu_EditarUsuario(history)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    actions.gu_eu_FormEditarHandleChangeInput(e)
    actions.gu_eu_validacionesEditarUsuarioOnBlur(e)
  }

  return (
    <BasicLayout>
      {modales.activeEliminar && (
        <ModalDelete
          title='Eliminar usuario'
          detail='¿Seguro que quieres eliminar a este usuario? Esta acción no se puede deshacer.'
          messageAction='Eliminar'
          actionDelete={() => actions.gu_eu_EliminarUsuarioConfirm(history)}
          closeModalDelete={() => dispatch(gu_eu_OpenModalEliminarUsuario(false))}
          Styles={{minWidth: '25%', maxWidth: '700px'}}
        />
      )}
      <div className='header'>
        <Link to='/gestion-usuarios/listar-usuarios' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Editar Usuario</h3>
      </div>
      <div className='separador'></div>
      <form className='w-100 mt-16' onSubmit={submit} >
        <div
          id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
          className='w-layout-layout bill-section wf-layout-layout'
        >
          {/* --------------- CARD INFORMACIÓN ----------------------- */}
          <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
            <div className='card w-form'>
              <div
                className='form-content'
                data-wf-page-id='64b58c72be2b65200b1e6fa6'
                data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
              >
                <div>
                  <h3 className='card-title l'>Usuario</h3>
                </div>
                <div className='form-separator'></div>
                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='username' className='field-label m'>
                      Nombre de usuario
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='username'
                      placeholder='Nombre de usuario'
                      id='username'
                      disabled={true}
                      value={formUser.username}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={100}
                    />
                    {formError.username ? (
                      <p className='alert s'>{formError.username}</p>
                    ) : formError.passwd || formError.passwd2 ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'></div>
                  <div className='label-input'></div>
                </div>
                <div>
                  <h3 className='card-title l'>Información</h3>
                </div>
                <div className='form-separator'></div>
                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='first_name' className='field-label m'>
                      Primer nombre
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='first_name'
                      placeholder='Primer nombre'
                      id='first_name'
                      value={formUser.first_name}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.first_name ? (
                      <p className='alert s'>{formError.first_name}</p>
                    ) : formError.second_name || formError.third_name ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='second_name' className='field-label m'>
                      Segundo nombre
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='second_name'
                      placeholder='Segundo nombre'
                      id='second_name'
                      value={formUser.second_name}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.second_name ? (
                      <p className='alert s'>{formError.second_name}</p>
                    ) : formError.first_name || formError.third_name ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='third_name' className='field-label m'>
                      Tercer nombre
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='third_name'
                      placeholder='Tercer nombre'
                      id='third_name'
                      value={formUser.third_name}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.third_name ? (
                      <p className='alert s'>{formError.third_name}</p>
                    ) : formError.first_name || formError.second_name ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='last_name' className='field-label m'>
                      Primer apellido
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='last_name'
                      placeholder='Primer apellido'
                      id='last_name'
                      value={formUser.last_name}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.last_name ? (
                      <p className='alert s'>{formError.last_name}</p>
                    ) : formError.last_name2 || formError.last_name_married ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='last_name2' className='field-label m'>
                      Segundo apellido
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='last_name2'
                      placeholder='Segundo apellido'
                      id='last_name2'
                      value={formUser.last_name2}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.last_name2 ? (
                      <p className='alert s'>{formError.last_name2}</p>
                    ) : formError.last_name || formError.last_name_married ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='last_name_married' className='field-label m'>
                      Apellido de casada
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='last_name_married'
                      placeholder='Apellido de casada'
                      id='last_name_married'
                      value={formUser.last_name_married}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={15}
                    />
                    {formError.last_name_married ? (
                      <p className='alert s'>{formError.last_name_married}</p>
                    ) : formError.last_name || formError.last_name2 ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='birth_date' className='field-label m'>
                      Fecha de nacimiento
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <input autoComplete='off'
                      type='date'
                      className='m text-field w-input'
                      name='birth_date'
                      placeholder='Fecha de nacimiento'
                      id='birth_date'
                      value={formUser.birth_date}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                    />
                    {formError.birth_date ? (
                      <p className='alert s'>{formError.birth_date}</p>
                    ) : formError.nit || formError.id_number ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='tipoDocumento' className='field-label m'>
                      Tipo de documento de identificación
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <select
                      autoFocus
                      id='tipoDocumento'
                      name='tipoDocumento'
                      data-name=''
                      className='m text-field w-select'
                      value={formUser.tipoDocumento}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                    >
                      <option value={''} disabled>Selecciona una opción</option>
                      {tipoDocumento.map((tipo) => (
                        <option value={tipo?.codigo} key={tipo?.codigo}>
                          {tipo?.valor}
                        </option>
                      ))}
                    </select>
                    {formError.tipoDocumento && <p className='alert s'>{formError.tipoDocumento}</p>}
                  </div>
                </div>
                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='id_number' className='field-label m'>
                      {formUser.nombreTipoDocumento || 'Número de identificación'}
                    </label>
                    <input
                      autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='id_number'
                      data-name='id_number'
                      placeholder={`Número de ${formUser.nombreTipoDocumento || 'Identificación'}`}
                      id='id_number'
                      disabled={formUser.tipoDocumento ? false : true}
                      maxLength={14}
                      value={formUser.id_number}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                    />
                    {formError.id_number && <p className='alert s'>{formError.id_number}</p>}
                  </div>
                  <Autorizado roles={ROLES_GESTION_DE_ROLES}>
                    <div className='label-input'>
                      <label htmlFor='role_access_user' className='field-label m'>
                        Rol del usuario
                        <span style={{color: 'red'}}>*</span>
                      </label>
                      <select
                        id='role_access_user'
                        name='role_access_user'
                        className='m text-field w-select'
                        value={formUser.role_access_user || String(ROL_POR_OMISION)}
                        onChange={handleChange}
                      >
                        {CATALOGO_ROLES.map((rol) => (
                          <option value={String(rol.id)} key={rol.id}>
                            {rol.nombre}
                          </option>
                        ))}
                      </select>
                      {formError.role_access_user && (
                        <p className='alert s'>{formError.role_access_user}</p>
                      )}
                    </div>
                  </Autorizado>
                </div>
              </div>
            </div>
          </div>

          {/* --------------- CARD CONTACTO ----------------------- */}
          <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
            <div className='card w-form' style={{height: 'auto'}}>
              <div
                className='form-content'
                data-wf-page-id='64b58c72be2b65200b1e6fa6'
                data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
              >
                <div>
                  <h3 className='card-title l'>Contacto</h3>
                </div>
                <div className='form-separator'></div>

                <div className={`ef-form-producto-div4`}>
                  <div className='label-input'>
                    <label htmlFor='email' className='field-label m'>
                      Correo electrónico
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <input autoComplete='off'
                      type='type'
                      className='m text-field w-input'
                      name='email'
                      placeholder='Correo electrónico'
                      id='email'
                      value={formUser.email}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={45}
                    />
                    {formError.email ? (
                      <p className='alert s'>{formError.email}</p>
                    ) : formError.phone_number || formError.location ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='phone_number' className='field-label m'>
                      Teléfono celular
                      <span style={{color: 'red'}}>*</span>
                    </label>
                    <InputPhone
                      disabled = {false}
                      className='m text-field w-input'
                      name='phone_number'
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      value={formUser.phone_number}
                    />
                    {/* <input autoComplete='off'
                      type='tel'
                      placeholder='Teléfono celular'
                      id='phone_number'
                      maxLength={15}
                    /> */}
                    {formError.phone_number ? (
                      <p className='alert s'>{formError.phone_number}</p>
                    ) : formError.email || formError.location ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='label-input'>
                    <label htmlFor='location' className='field-label m'>
                      Dirección
                    </label>
                    <input autoComplete='off'
                      type='text'
                      className='m text-field w-input'
                      name='location'
                      placeholder='Dirección'
                      id='location'
                      value={formUser.location}
                      onChange={handleChange}
                      onBlur={actions.gu_eu_validacionesEditarUsuarioOnBlur}
                      maxLength={100}
                    />
                    {formError.location ? (
                      <p className='alert s'>{formError.location}</p>
                    ) : formError.email || formError.phone_number ? (
                      <p className='alert s'>&nbsp;</p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='m button-actions  mt-16'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
            padding: '1%',
          }}
        >
          <button
            type='button'
            className='m button transparent w-inline-block w-auto'
            onClick={() => dispatch(gu_eu_OpenModalEliminarUsuario(true))}
          >
            <div>Eliminar usuario</div>
          </button>
          <div
            style={{display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'space-between'}}
          >
            <button
              type='button'
              className='m button transparent w-inline-block w-auto'
              onClick={cancelar}
            >
              <div>Cancelar</div>
            </button>
            <button type='submit' className='m button w-inline-block w-auto'>
              <img src={WhiteCheck} loading='lazy' alt='Actualizar' />
              <div>Actualizar</div>
            </button>
          </div>
        </div>
      </form>
    </BasicLayout>
  )
}

export default EditarUsuario
